import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class Footer extends Component {
    render() {
        return (
            <footer>
                <div id="footer">
                    <div className="container">
                        <div className="btn-link-footer">
                            <div className="row">
                                <div className="col-6">
                                    <Link to="/for-club" className="btn btn-custom-footer float-right">
                                        部活動窓口
                                    </Link>
                                </div>
                                <div className="col-6">
                                    <Link to="/for-company" className="btn btn-custom-footer btn-custom-right">
                                        企業の方はこちら
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="menu-footer">
                            <ul>
                                <li>
                                    <a href="http://dsc-web.com/" target="_blank">運営会社</a>
                                </li>
                                <li>
                                    <Link to="/law">特定商取引法に関する表記</Link>
                                </li>
                                <li>
                                    <Link to="/privacy">プライバシーポリシー</Link>
                                </li>
                                <li>
                                    <Link to="/terms">利用規約</Link>
                                </li>
                                <li>
                                    <Link to="/faq">よくあるご質問</Link>
                                </li>
                                <li>
                                    <Link to="/sitepolicy">サイトポリシー</Link>
                                </li>
                                <li>
                                    <Link to="/link">リンク</Link>
                                </li>
                                <li>
                                    <Link to="/contact">お問い合わせ</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="menu-footer-mb">
                            <div className="row">
                                <div className="col-6">
                                    <ul className="col-menu-footer-mb">
                                        <li>
                                            <a href="http://dsc-web.com/" target="_blank">運営会社</a>
                                        </li>
                                        <li>
                                            <Link to="/privacy">プライバシーポリシー</Link>
                                        </li>
                                        <li>
                                            <Link to="/faq">よくあるご質問</Link>
                                        </li>
                                        <li>
                                            <Link to="/link">リンク</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-6">
                                    <ul className="col-menu-footer-mb">
                                        <li>
                                            <Link to="/law">特定商取引法に関する表記</Link>
                                        </li>
                                        <li>
                                            <Link to="/terms">利用規約</Link>
                                        </li>
                                        <li>
                                            <Link to="/sitepolicy">サイトポリシー</Link>
                                        </li>
                                        <li>
                                            <Link to="/contact">お問い合わせ</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="copyright-footer">
                        <img src="/images/logo.png" className="img-fluid" />
                        <div>copyright©2018 sashiire All rights reserved.</div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer